import { ProxySlots } from './ProxySlots';
import { SlotsProps } from './types';

export const Slots = (props: SlotsProps) => (
  <ProxySlots {...props} constraints={props.constraints} />
);
